import CardIcon from "components/icons/CardIcon";
import PocketIcon from "components/icons/PocketIcon";
import IconAndInformation from "components/common/IconAndInformation";
import Others from "components/icons/Others";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function ListElement({ icon, bottom, top, money }) {
  return (
    <s.ListWrapper>
      <IconAndInformation
        style={{ marginBottom: "16px" }}
        icon={icon}
        bottom={bottom}
        top={top}
      />
      <s.TextRightMoney>{money || 0}</s.TextRightMoney>
    </s.ListWrapper>
  );
}

function PaymentType(props) {
  const { t } = useTranslation();
  const { paymentType } = props;

  const money = paymentType.find((element) => element?.name === "cash");
  const card = paymentType.find((element) => element?.name === "card");
  const other = paymentType.filter((element) => element?.name === "others");

  let otherTotal = 0;
  let otherCount = 0;

  other.forEach((element) => {
    otherTotal += parseInt(element?.total);
    otherCount += parseInt(element?.count);
  });

  const { currencyFormat } = useBusinessContext();

  return (
    <s.Container>
      {props.loading ? (
        <Loading height="200px" size="middle" />
      ) : (
        <>
          <s.TopElementContainer>
            <s.Title>
              {t("containers.Dashboard.PaymentType.paymentType")}
            </s.Title>
            <s.LastDaysText>
              {t("containers.Dashboard.PaymentType.last30Days")}
            </s.LastDaysText>
          </s.TopElementContainer>
          <ListElement
            icon={<PocketIcon />}
            bottom={`${money?.count || 0} ${t(
              "containers.Dashboard.PaymentType.payments"
            )}`}
            top={t("containers.Dashboard.PaymentType.cash")}
            money={currencyFormat(money?.total)}
          />
          <ListElement
            icon={<CardIcon />}
            bottom={`${t("containers.Dashboard.PaymentType.payments")}`}
            top={t("containers.Dashboard.PaymentType.card")}
            money={currencyFormat(card?.total)}
          />
          <ListElement
            icon={<Others />}
            bottom={`${otherCount || 0} ${t(
              "containers.Dashboard.PaymentType.payments"
            )}`}
            top={t("containers.Dashboard.PaymentType.others")}
            money={currencyFormat(otherTotal)}
          />
        </>
      )}
    </s.Container>
  );
}

export default PaymentType;
